export interface ITenantsStore {
  currentTenant?: any;
  tenants: any[];
  invitations: any[];
}

export const tenantsStore = {
  tenants: [],
  invitations: [],
};
